/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */
import * as pxp from './PXPApp'
import { componentApi, loadTranslations } from 'common'


export class FourYearPlanner {
  async GetDataForAgu(agu : string) : Promise<pxp.FourYearPlannerVM> {
    return await componentApi.call('pxp', 'four-year-planner', 'FourYearPlanner', 'GetDataForAgu', {
      agu,
    });
  }
  async BeginEditing(agu : string) : Promise<pxp.FourYearPlannerVM> {
    return await componentApi.call('pxp', 'four-year-planner', 'FourYearPlanner', 'BeginEditing', {
      agu,
    });
  }
  async Commit(agu : string) : Promise<pxp.FourYearPlannerVM> {
    return await componentApi.call('pxp', 'four-year-planner', 'FourYearPlanner', 'Commit', {
      agu,
    });
  }
  async AddCourse(agu : string, orgYearGU : string, stuPrimaryOrgYrGU : string, gradeCode : string, courseGU : string, altCourseGU : string, selectedHomeSchoolCurriculum : string) : Promise<pxp.FourYearPlannerVM> {
    return await componentApi.call('pxp', 'four-year-planner', 'FourYearPlanner', 'AddCourse', {
      agu,
      orgYearGU,
      stuPrimaryOrgYrGU,
      gradeCode,
      courseGU,
      altCourseGU,
      selectedHomeSchoolCurriculum,
    });
  }
  async RemoveCourse(agu : string, gradeCode : string, courseGU : string, altCourseGU : string) : Promise<pxp.FourYearPlannerVM> {
    return await componentApi.call('pxp', 'four-year-planner', 'FourYearPlanner', 'RemoveCourse', {
      agu,
      gradeCode,
      courseGU,
      altCourseGU,
    });
  }
  async ChangeGradReqDef(agu : string, gradReqDefGU : string) : Promise<pxp.FourYearPlannerVM> {
    return await componentApi.call('pxp', 'four-year-planner', 'FourYearPlanner', 'ChangeGradReqDef', {
      agu,
      gradReqDefGU,
    });
  }
  async ChangeDiplomaType(agu : string, diplomaType : string) : Promise<pxp.FourYearPlannerVM> {
    return await componentApi.call('pxp', 'four-year-planner', 'FourYearPlanner', 'ChangeDiplomaType', {
      agu,
      diplomaType,
    });
  }
  async ResetCoursePlan(agu : string) : Promise<pxp.FourYearPlannerVM> {
    return await componentApi.call('pxp', 'four-year-planner', 'FourYearPlanner', 'ResetCoursePlan', {
      agu,
    });
  }
  async ChangeCareerPlan(agu : string, careerPlanGU : string) : Promise<pxp.FourYearPlannerVM> {
    return await componentApi.call('pxp', 'four-year-planner', 'FourYearPlanner', 'ChangeCareerPlan', {
      agu,
      careerPlanGU,
    });
  }
}

export class FourYearPlannerTransformer {
  async Transform(htmlStream : any) : Promise<any> {
    return await componentApi.call('pxp', 'four-year-planner', 'FourYearPlannerTransformer', 'Transform', {
      htmlStream,
    });
  }
}
export default new FourYearPlanner()
